import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FirestoreService } from 'src/app/services/firestore.service';

@Component({
  selector: 'app-popular-business-list',
  templateUrl: './popular-business-list.component.html',
  styleUrls: ['./popular-business-list.component.sass']
})
export class PopularBusinessListComponent implements OnInit {

  items;
  catItems;
  logoImage: string = "./assets/img/no-logo.png"
  
  constructor(    
    private route: Router,
    public db: FirestoreService
  ) { }
  
  ngOnInit(): void {
    this.items = this.db.getPopularBusinessLists();
    this.catItems = this.db.getPopularBusinessCategoryLists();
  };
  
  routeToBusinessDetailsPage(docId){
    this.route.navigateByUrl('business/'+docId);
  };
  routeToBusinessListPage(name){
    this.route.navigateByUrl('businesses/'+name);
  };
  routeToBusinessCategoryListPage(){
    this.route.navigateByUrl('business/categories');
  };
  
}
